import React from 'react';
import { TemplateJobProjectionResponse, ProjectedTaskDetail } from "../../../../interfaces/adminUser/adminRecurringTaskStats/AdminRecurringTaskJobStats";

interface CalendarProps {
    year: number;
    month: number;
    data: TemplateJobProjectionResponse;
    // UPDATED: Pass the actual data back, not just a key string
    onDayClick: (tasks: ProjectedTaskDetail[], dateLabel: string) => void;
}

const CalendarView: React.FC<CalendarProps> = ({ year, month, data, onDayClick }) => {
    const firstDayOfMonth = new Date(year, month - 1, 1).getDay(); // 0 = Sunday
    const daysInMonth = new Date(year, month, 0).getDate();
    
    const blanksArray = Array.from({ length: firstDayOfMonth }, (_, i) => i);
    const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="grid grid-cols-7 bg-gray-50 text-gray-500 font-bold text-xs uppercase tracking-wider text-center py-3 border-b border-gray-200">
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => <div key={d}>{d}</div>)}
            </div>

            {/* Grid */}
            <div className="grid grid-cols-7 auto-rows-fr bg-gray-200 gap-px">
                {/* Blanks */}
                {blanksArray.map(i => (
                    <div key={`blank-${i}`} className="bg-gray-50 h-32"></div>
                ))}

                {/* Days */}
                {daysArray.map(day => {
                    // FIX: Lookup using the simple day string ("1", "11", "15") 
                    // consistent with your API response `dailyProjections: { "11": [...] }`
                    const dayKey = day.toString();
                    
                    // Access 'dailyProjections' (not dailyDetails)
                    const tasks = data.dailyProjections && data.dailyProjections[dayKey] 
                        ? data.dailyProjections[dayKey] 
                        : [];
                        
                    const count = tasks.length;
                    
                    return (
                        <div 
                            key={day} 
                            onClick={() => onDayClick(tasks, `${year}-${month}-${day}`)}
                            className={`h-32 p-2 relative group transition-colors cursor-pointer
                                ${count > 0 ? 'bg-white hover:bg-purple-50' : 'bg-white'}`}
                        >
                            <span className={`text-sm font-semibold ${count > 0 ? 'text-gray-800' : 'text-gray-400'}`}>{day}</span>
                            
                            {count > 0 && (
                                <div className="mt-2 animate-fade-in">
                                    <span className="inline-block bg-purple-100 text-[#7B5CD6] text-xs px-2 py-0.5 rounded-full font-bold mb-1">
                                        {count} Scheduled
                                    </span>
                                    <div className="space-y-0.5">
                                        {tasks.slice(0, 2).map((t, idx) => (
                                            <div key={idx} className="text-[10px] text-gray-500 truncate pl-1 border-l-2 border-purple-200">
                                                {t.templateTitle}
                                            </div>
                                        ))}
                                        {count > 2 && (
                                            <div className="text-[10px] text-gray-400 pl-1 italic">
                                                + {count - 2} more...
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CalendarView;